export {default as HomePage} from './page'


// WEBPACK FOOTER //
// ./src/pages/home/index.js